import { memo, useCallback } from 'react';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import UINumberInput from 'UIComponents/input/UINumberInput';
import { getMonthsPerPeriod, getPeriodFromMonths } from '../v2/utils/period';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputMonthPeriod = props => {
  const {
    onChange,
    inputRef,
    value
  } = props;
  const handleChange = useCallback(({
    target: {
      value: newValue
    }
  }) => {
    const termValue = getPeriodFromMonths(newValue);
    onChange(SyntheticEvent(termValue));
  }, [onChange]);
  const monthsValue = getMonthsPerPeriod(value);
  return /*#__PURE__*/_jsx(UINumberInput, Object.assign({}, getTransferrableProps(props), {
    min: 0,
    onChange: handleChange,
    inputRef: inputRef
    // @ts-expect-error UINumberInput propTypes allow 'null', but TS types do not; see https://git.hubteam.com/HubSpot/UIComponents/issues/10822
    ,
    value: monthsValue
  }));
};
export default /*#__PURE__*/memo(PropertyInputMonthPeriod);